import React from 'react';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';
import { useStyles } from './FsPhoneNumberInput.style';

const FsPhoneNumberInput: React.FC<PhoneInputProps> = ({
  inputProps,
  ...props
}) => {
  const { container: containerClass } = useStyles();
  return (
    <PhoneInput
      {...{ ...props, containerClass }}
      inputProps={{ autoComplete: 'none', ...inputProps }}
    />
  );
};

export default FsPhoneNumberInput;
